/**
 * Types
 */

import type { ValueOf } from '@shared/types/Helpers';

const roles = {
  INITIATOR: 'initiator',
  FIRST_VALIDATOR: 'validator-1',
  SECOND_VALIDATOR: 'validator-2',
  LEGACY_ADMIN: 'admin',
  CONTACT_ADMIN: 'contact-admin',
  TICKET_ADMIN: 'ticket-admin',
  SUPER_ADMIN: 'super-admin',
  ANALYTICS_ADMIN: 'analytics-admin',
  USER_ADMIN: 'user-admin',
  DECLARATION_ADMIN: 'declaration-admin',
  CONVENTIONS_ADMIN: 'conventions-admin',
  ADMIN_DQC: 'admin-analytics-dqc',
  ADMIN_DQC_EDITOR: 'admin-analytics-dqc-editor',
  ADMIN_DQC_MANAGER: 'admin-analytics-dqc-manager',
} as const;

const userRoles = [
  roles.INITIATOR,
  roles.FIRST_VALIDATOR,
  roles.SECOND_VALIDATOR,
] as const;

const adminRoles = [
  roles.CONTACT_ADMIN,
  roles.TICKET_ADMIN,
  roles.SUPER_ADMIN,
  roles.USER_ADMIN,
  roles.DECLARATION_ADMIN,
  roles.CONVENTIONS_ADMIN,
  roles.ADMIN_DQC,
  roles.ADMIN_DQC_EDITOR,
  roles.ADMIN_DQC_MANAGER,
] as const;

const baseAdminRoles = [
  roles.CONTACT_ADMIN,
  roles.TICKET_ADMIN,
  roles.SUPER_ADMIN,
  roles.USER_ADMIN,
  roles.DECLARATION_ADMIN,
  roles.CONVENTIONS_ADMIN,
] as const;

const DQCCreatorRole = [
  roles.ADMIN_DQC_EDITOR,
  roles.ADMIN_DQC_MANAGER,
] as const;

const legacyRoles = [roles.LEGACY_ADMIN, roles.ANALYTICS_ADMIN] as const;

type RolesType = ValueOf<typeof roles>;
type AdminRoleType = (typeof adminRoles)[number];
type UserRoleType = (typeof userRoles)[number];
type LegacyRoles = (typeof legacyRoles)[number];

export type { RolesType, AdminRoleType, UserRoleType, LegacyRoles };

export {
  roles,
  legacyRoles,
  adminRoles,
  baseAdminRoles,
  DQCCreatorRole,
  userRoles,
};
